import { Component, OnInit } from '@angular/core';
import { Dog } from 'src/app/shared/models/dog';
import { TrainedDog } from 'src/app/shared/models/trained-dog';
import { environment } from 'src/environments/environment';
import { Title } from '@angular/platform-browser';
import { PageModel } from 'src/app/shared/models/page-model';
import { PageService } from 'src/app/shared/services/page.service';
import { DogService } from 'src/app/shared/services/dog.service';
import { trigger, state, transition, style, animate } from '@angular/animations';
import { SeoService } from 'src/app/shared/helpers/seo.service';

@Component({
  selector: 'app-trained-dogs',
  templateUrl: './trained-dogs.component.html',
  styleUrls: ['./trained-dogs.component.css'],
  animations: [
    // the fade-in/fade-out animation.
    trigger('simpleFadeAnimation', [

      // the "in" style determines the "resting" state of the element when it is visible.
      state('in', style({ opacity: 1 })),

      // fade in when created. this could also be written as transition('void => *')
      transition(':enter', [
        style({ opacity: 0 }),
        animate(600)
      ]),

      // fade out when destroyed. this could also be written as transition('void => *')
      transition(':leave',
        animate(600, style({ opacity: 0 })))
    ])
  ]
})
export class TrainedDogsComponent implements OnInit {

  pageId = '2';
  pageModel: PageModel;

  trainedDogs: TrainedDog[];
  trainedDogsLoaded = false;

  constructor(
    private titleService: Title,
    private pageService: PageService,
    private dogService: DogService,
    private seoService: SeoService
  ) { }

  ngOnInit() {
    this.setTitle();
    this.loadPageDetails();
    this.loadTrainedDogs();
  }

  setTitle() {
    const basePageTitle = environment.basePageTitle;
    const currentPageTitle = 'Trained Dogs';
    this.titleService.setTitle(`${currentPageTitle}${basePageTitle}`);
  }

  loadPageDetails() {
    this.pageService.getPageById(this.pageId)
      .subscribe((response) => {

        this.pageModel = response;

        const metaData = {
          keywordsMeta: this.pageModel.headerCardSubTitle,
          authorMeta: 'Moccasin Creek Kennel - Longview, TX',
          descriptionMeta: this.pageModel.headerCardSubTitle,
          ogTitleMeta: this.pageModel.headerCardSubTitle,
          ogDescriptionMeta: this.pageModel.headerCardSubTitle,
          ogUrlMeta: window.location.href
        };

        this.seoService.setMetaTags(metaData);
        this.seoService.setCononicalUrl(window.location.href);

      });
  }

  loadTrainedDogs() {
    this.dogService.getAllPublicTrainedDogs()
      .subscribe((response) => {
        if (response) {
          this.trainedDogs = response;
          this.trainedDogsLoaded = true;
        } else {
          // TODO: redirect to custom error page
        }
      });
  }

}
